export function pathToName(path) {
    const match = path.match(/[ \w-]+?(?=\.)/);
    return match ? match[0] : path;
}
export function getProp(obj, path) {
    try {
        if (typeof path === 'string' && obj[path])
            return obj[path];
        const parts = path.split('.');
        const first = parts[0];
        if (first === '[number]') {
            return obj.map((v) => getProp(v, path.replace(`${first}.`, '')));
        }
        else if (obj[first])
            return getProp(obj[first], path.replace(`${first}.`, ''));
    }
    catch (error) {
        console.log(error);
        return;
    }
}
export function setProp(obj, value, path) {
    try {
        if (!value)
            return;
        let ref = obj;
        path.split('.').forEach(function (key, index, arr) {
            if (key === '[number]') {
                const otherParts = arr.splice(index + 1, arr.length);
                const newPath = otherParts.join('.');
                for (let i = 0; i < value.length; i++) {
                    const v = value[i];
                    const defaultRef = typeof ref[i] === 'object' && ref[i] !== null ? ref[i] : {};
                    ref[i] = defaultRef;
                    setProp(ref[i], v, newPath);
                }
            }
            else {
                const defValue = arr[index + 1] === '[number]' ? [] : {};
                const defaultRef = typeof ref[key] === 'object' && ref[key] !== null ? ref[key] : defValue;
                const assignment = index === arr.length - 1 ? value : defaultRef;
                ref = ref[key] = assignment;
            }
        });
    }
    catch (error) {
        console.log('Error setting prop', path, value);
        console.log(error);
    }
}
export const dateFormater = new Intl.DateTimeFormat('es-ES', { dateStyle: 'medium', timeStyle: 'short' });
export function normalizeItems(str) {
    return str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '');
}
export function debounce(func, waitFor) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), waitFor);
    };
}
export function throttle(func, limit) {
    let inThrottle;
    let lastResult;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
            lastResult = func.apply(context, args);
        }
        return lastResult;
    };
}
export function randomStr() {
    return Math.random().toString(36).substring(2, 9);
}
export function pluralize(text, num) {
    return num === 1 ? text : text + 's';
}
export function inputToPathname(input) {
    const trimmedInput = input.toLowerCase();
    const replacedSpaces = trimmedInput.replace(/\s+/g, '-');
    const sanitizedString = replacedSpaces.replace(/[^a-z0-9-_:*\/]/g, '');
    return sanitizedString;
}
export function replaceHTML(template, data) {
    return template.replace(/%(\w*)%/g, (_, key) => (key in data ? data[key] : ''));
}
